'use strict';

module.exports = function (farmName) {
  return encodeURIComponent(farmName.toLowerCase().replace(/[äÄ]/g, 'ae').replace(/[öÖô]/g, 'oe').replace(/[üÜ]/g, 'ue').replace(/[èéêë]/g, 'e').replace(/[àâ]/g, 'a').replace(/[ùû]/g, 'u').replace(/[îï]/g, 'i').replace(/[ç]/g, 'c')).replace(/[_."'(),!]/g, '-').replace(/%[a-fA-F0-9]{2}/g, '-').replace(/-+/g, '-').replace(/-$/, '').replace(/^-/, '');
};


//////////////////
// WEBPACK FOOTER
// ./server/services/url-encoder/index.js
// module id = 882
// module chunks = 0